/* eslint-disable jira/filename-case */
const PREFIX = 'atlassian-navigation-';
const SEPARATOR = '--';

const isValid = (value?: string): boolean => value != null && value !== '';

export const testIdConcat = (id?: string, ...items: string[]): string | undefined =>
	[id, ...items].filter(Boolean).join(SEPARATOR).toLowerCase();

export const testIdGenerate = (
	first: string | null | undefined,
	...rest: string[]
): string | undefined =>
	// @ts-expect-error - TS2345 - Argument of type 'string | null | undefined' is not assignable to parameter of type 'string | undefined'.
	testIdConcat(PREFIX + (isValid(first) ? `-${first}` : ''), ...rest);
